import Button from 'atoms/Button/button';
import FormField from 'components/community/common/FormField';
import { StyledSvgSprite } from 'components/general/SVGSprite';
import { Box, FlexDiv } from 'components/molecules/utils/basicComponents';
import { getCustomScroll } from 'components/molecules/utils/customStyles';
import { alpha } from 'foundations/theme';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled from 'styled-components';
import { cdnImage } from 'utils/core';
import DatePicker from '../../../../general/Form/DateTimePicker';
import { getAmbienceColorId } from 'components/community/common/utils';
import useTheme from 'hooks/useTheme';

export default function DateTime({
    name,
    dateFormat,
    onChange,
    placeholder,
    defaultDate,
    title,
    typeDateTime,
    showSidemenu,
    setShowSideMenu,
    onClose,
    newOnBoardingFlow = false,
    getMinDate,
    pageMode = false,
}) {
    const status = showSidemenu === 'starting_on' ? 'start' : 'end';
    const { theme } = useTheme();
    const getColorId = (colorId) =>
        getAmbienceColorId({ colorId, isAgnostic: newOnBoardingFlow, theme });
    return (
        <>
            <FlexDiv alignItems={'center'} mb={2} position={'relative'}>
                <Typography
                    variant={'subtitle2'}
                    color={`ambience.${getColorId(23)}`}
                >
                    {title}
                </Typography>
                <ButtonClose variant={'link'} onClick={onClose}>
                    <StyledSvgSprite
                        icon={'icon-times'}
                        height={'24px'}
                        width={'24px'}
                        fill={`ambience.${getColorId(23)}`}
                    />
                </ButtonClose>
            </FlexDiv>
            <StyledBox
                mb={3}
                forceDarkMode={newOnBoardingFlow ? false : true}
                verticalWidth={'12px'}
            >
                {typeDateTime === 'date' && (
                    <FormFieldWIcon
                        id={name}
                        name={name}
                        custom
                        variant={'v2'}
                        label={'Date'}
                        subLabel={`Set the ${status} date for your event`}
                        isLightBg={newOnBoardingFlow ? false : true}
                        className={'custom-day-event'}
                        ambienceColorId={getColorId}
                        onBoardingFlowEnabled={newOnBoardingFlow}
                        pageMode={pageMode}
                    >
                        <DatePicker
                            name={name}
                            dateFormat={dateFormat}
                            onChange={onChange}
                            placeholder={placeholder}
                            defaultDate={defaultDate}
                            minDate={getMinDate(
                                showSidemenu === 'starting_on'
                                    ? 'initDate'
                                    : 'finalDate',
                                showSidemenu === 'starting_on'
                            )}
                            open
                        />
                        <StyledSvgSprite
                            position={'absolute'}
                            top={'20px'}
                            right={'18px'}
                            icon={'calendar-icon'}
                            height={16}
                            width={16}
                            fill={`ambience.${getColorId(8)}`}
                        />
                    </FormFieldWIcon>
                )}
            </StyledBox>
        </>
    );
}
const FormFieldWIcon = styled(FormField)`
    &.form-field.custom-day-event {
        border-radius: 0;
        padding: 0;
        background-color: transparent;
        margin-bottom: 16px;
        > .react-datepicker-wrapper {
            background-color: ${({ theme, ambienceColorId }) =>
                theme.colors.ambience[ambienceColorId(3)]};
            padding: 16px;
            border-radius: 8px;
            margin-bottom: 24px;
        }
        .react-datepicker-popper {
            position: relative !important;
            transform: none !important;
            &[data-placement^='bottom'] {
                margin-top: 0;
                .react-datepicker__triangle {
                    display: none;
                }
            }
            .react-datepicker {
                width: 100%;
                font-family: ${({ theme }) => theme.fonts.book};
                background-color: transparent;
                border: none;
                .react-datepicker__navigation {
                    top: -5px;
                    border: none;
                    height: 32px;
                    width: 32px;
                    &.react-datepicker__navigation--next {
                        background: url('${cdnImage(
                            'images/ic-calendar-arrow-right.svg'
                        )}') no-repeat center;
                        background-size:16px;
                    }
                    &.react-datepicker__navigation--previous {
                        background: url('${cdnImage(
                            'images/ic-calendar-arrow-left.svg'
                        )}') no-repeat center;
                        background-size:16px;
                    }
                    &:focus {
                        outline: 0;
                    }
                }
                .react-datepicker__month-container {
                    width: 100%;
                    .react-datepicker__header {
                        border-bottom: none;
                        border-top-left-radius: 0;
                        border-top-right-radius: 0;
                        padding-top: 0;
                        background-color: transparent;
                        .react-datepicker__current-month {
                            font-weight: normal;
                            font-size: 14px;
                            margin-bottom: 8px;
                        }
                        .react-datepicker__day-names {
                            margin-bottom: 10px;
                            .react-datepicker__day-name {
                                width: 14.28%;
                                margin: 0;
                                font-size: 12px;
                                line-height: 16px;
                                color:${({ theme, ambienceColorId }) =>
                                    theme.colors.ambience[ambienceColorId(23)]};
                                    &:first-child,&:last-child{
                                        color:${({
                                            theme,
                                            onBoardingFlowEnabled,
                                        }) =>
                                            onBoardingFlowEnabled
                                                ? theme.colors.accentPrimary[1]
                                                : theme.colors.semantic[1]};
                                    }
                            }
                        }
                    }
                    .react-datepicker__month {
                        border: 1px solid
                            ${({ theme, ambienceColorId }) =>
                                theme.colors.ambience[ambienceColorId(3)]};
                        border-radius: 8px;
                        margin: 0;
                        .react-datepicker__week {
                            .react-datepicker__day {
                                width: 14.28%;
                                margin: 0;
                                height: 44px;
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                                border-right: 1px solid
                                    ${({ theme, ambienceColorId }) =>
                                        theme.colors.ambience[
                                            ambienceColorId(3)
                                        ]};
                                border-bottom: 1px solid
                                    ${({ theme, ambienceColorId }) =>
                                        theme.colors.ambience[
                                            ambienceColorId(3)
                                        ]};
                                color: ${({ theme, ambienceColorId }) =>
                                    theme.colors.ambience[ambienceColorId(14)]};
                                transition: all 0.3s ease-in-out;
                                &.react-datepicker__day--disabled,
                                &.react-datepicker__day--outside-month {
                                    color: ${({ theme, ambienceColorId }) =>
                                        theme.colors.ambience[
                                            ambienceColorId(6)
                                        ]};
                                        &.react-datepicker__day--weekend{
                                            color:${({
                                                theme,
                                                onBoardingFlowEnabled,
                                            }) =>
                                                onBoardingFlowEnabled
                                                    ? theme.colors
                                                          .accentPrimary[1]
                                                    : theme.colors.semantic[1]};
                                                opacity:0.5;
                                        }
                                        &.react-datepicker__day--weekend{
                                            color:${({
                                                theme,
                                                onBoardingFlowEnabled,
                                            }) =>
                                                onBoardingFlowEnabled
                                                    ? theme.colors
                                                          .accentPrimary[1]
                                                    : theme.colors.semantic[1]};
                                                opacity:0.5;
                                        }
                                }
                                &.react-datepicker__day--weekend{
                                    color:${({
                                        theme,
                                        onBoardingFlowEnabled,
                                    }) =>
                                        onBoardingFlowEnabled
                                            ? theme.colors.accentPrimary[1]
                                            : theme.colors.semantic[1]};
                                }
                                &.react-datepicker__day--selected {
                                    position: relative;
                                    background-color: transparent;
                                    color: ${({ theme, ambienceColorId }) =>
                                        theme.colors.ambience[
                                            ambienceColorId(23)
                                        ]};
                                    &.react-datepicker__day--weekend{
                                        color:${({
                                            theme,
                                            onBoardingFlowEnabled,
                                        }) =>
                                            onBoardingFlowEnabled
                                                ? theme.colors.accentPrimary[1]
                                                : theme.colors.semantic[1]};
                                    }
                                    font-family: ${({ theme }) =>
                                        theme.fonts.bold};
                                    &:before {
                                        content: '';
                                        height: 100%;
                                        width: 100%;
                                        border: 1px solid
                                            ${({
                                                theme,
                                                onBoardingFlowEnabled,
                                            }) =>
                                                onBoardingFlowEnabled
                                                    ? theme.colors.semantic[1]
                                                    : theme.colors
                                                          .accentPrimary[1]};
                                        background-color:${({
                                            theme,
                                            onBoardingFlowEnabled,
                                        }) =>
                                            alpha(
                                                onBoardingFlowEnabled
                                                    ? theme.colors.semantic[1]
                                                    : theme.colors
                                                          .accentPrimary[1],
                                                0.1
                                            )};
                                        border-radius: 4px;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        transition: all 0.3s ease-in-out;
                                    }
                                }
                                &.react-datepicker__day--keyboard-selected {
                                    background-color: transparent;
                                    position: relative;
                                    font-family: ${({ theme }) =>
                                        theme.fonts.book};
                                        &:before{
                                        border:0;
                                        content: '';
                                        height: 100%;
                                        width: 100%;
                                        border-radius: 4px;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        transition: all 0.3s ease-in-out;
                                        background-color:${({
                                            theme,
                                            onBoardingFlowEnabled,
                                        }) =>
                                            alpha(
                                                onBoardingFlowEnabled
                                                    ? theme.colors.semantic[1]
                                                    : theme.colors
                                                          .accentPrimary[1],
                                                0.1
                                            )};
                                        }
                                }
                                &:last-child {
                                    border-right: 0;
                                }
                            }
                            &:last-child {
                                .react-datepicker__day {
                                    border-bottom: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .react-datepicker-wrapper {
        width: 100%;
    }
    .react-datepicker__input-container {
        position: relative;
        z-index: 1;
        input {
            padding-right: 20px;
            color: ${({ theme, ambienceColorId }) =>
                theme.colors.ambience[ambienceColorId(19)]};
        }
    }
`;
const StyledBox = styled(Box)`
    max-height: calc(100vh - 120px);
    overflow-y: auto;
    overflow-x: hidden;
    ${({ theme, forceDarkMode, verticalWidth }) =>
        getCustomScroll({ theme, forceDarkMode, verticalWidth })};
`;
const ButtonClose = styled(Button)`
    position: absolute;
    right: 0px;
    z-index: 1090;
    &:hover {
        opacity: 0.85;
    }
    &:focus {
        outline: 0;
        box-shadow: none;
    }
`;
